/**
 * crypton-demo surface config
 * Set these in services/crypton-demo/.env (or .env.local for local overrides)
 */
export const MAIN_URL  = process.env.REACT_APP_MAIN_URL  || 'http://localhost:3000';
export const API_BASE  = process.env.REACT_APP_API_BASE  || '';
